var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusAhead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_646_508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 15.5C9.85654 15.5 11.637 14.7625 12.9498 13.4497C14.2625 12.137 15 10.3565 15 8.49996C15 6.64344 14.2625 4.86295 12.9498 3.5502C11.637 2.23744 9.85654 1.49994 8.00002 1.49994C6.1435 1.49994 4.36302 2.23744 3.05026 3.5502C1.7375 4.86295 1 6.64344 1 8.49996C1 10.3565 1.7375 12.137 3.05026 13.4497C4.36302 14.7625 6.1435 15.5 8.00002 15.5Z",
    stroke: "#008900",
    strokeWidth: 1.41347,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.44604 9.5769C4.98451 11.5154 7.13836 12.7 9.07683 12.1615C10.2614 11.7308 11.2307 10.7615 11.5538 9.5769",
    stroke: "#008900",
    strokeWidth: 1.41347,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57685 6.88459C5.50544 6.88459 5.43696 6.85623 5.38647 6.80574C5.33598 6.75525 5.30762 6.68677 5.30762 6.61536C5.30762 6.54396 5.33598 6.47548 5.38647 6.42499C5.43696 6.3745 5.50544 6.34613 5.57685 6.34613",
    stroke: "#008900",
    strokeWidth: 1.41347,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5769 6.88459C5.64831 6.88459 5.71679 6.85623 5.76728 6.80574C5.81777 6.75525 5.84614 6.68677 5.84614 6.61536C5.84614 6.54396 5.81777 6.47548 5.76728 6.42499C5.71679 6.3745 5.64831 6.34613 5.5769 6.34613",
    stroke: "#008900",
    strokeWidth: 1.41347,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.423 6.88459C10.3516 6.88459 10.2832 6.85623 10.2327 6.80574C10.1822 6.75525 10.1538 6.68677 10.1538 6.61536C10.1538 6.54396 10.1822 6.47548 10.2327 6.42499C10.2832 6.3745 10.3516 6.34613 10.423 6.34613",
    stroke: "#008900",
    strokeWidth: 1.41347,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4231 6.88459C10.4945 6.88459 10.563 6.85623 10.6135 6.80574C10.664 6.75525 10.6923 6.68677 10.6923 6.61536C10.6923 6.54396 10.664 6.47548 10.6135 6.42499C10.563 6.3745 10.4945 6.34613 10.4231 6.34613",
    stroke: "#008900",
    strokeWidth: 1.41347,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_646_508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusAhead);
export default __webpack_public_path__ + "static/media/status-ahead.44024df45239069524612c5ec219ba50.svg";
export { ForwardRef as ReactComponent };